export default {"src":"/_next/static/media/blondies.61ef7a9a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};